module.exports = __webpack_public_path__ + "static/img/X9摄像头.db904d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD200/X9摄像头.png
// module id = ekuq
// module chunks = 0